import { PageStatusData } from "../../PageStatusData";
import { ServiceResponse } from "../ServiceResponse";

export class PageStatusesResponse extends ServiceResponse {
  public PageStatuses: PageStatusData[] | null = null;
}
